import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { toInteger } from 'lodash';
import { formatWholeDollarAmount } from '@utils/money';
import { PriceDisplay, Maybe } from '@gql';
const DISPLAY_TOTALS = true;
const rateBeforeSavings = (nightlyRate: number): number => {
  return nightlyRate * 1.15;
};
interface ListingPriceDisplayProps {
  priceDisplay?: Pick<PriceDisplay, 'baseAmountCents' | 'checkInDate' | 'checkOutDate' | 'nights' | 'subtotalWithoutTaxesCents'>;
  minPrice: Maybe<number>;
  maxPrice: Maybe<number>;
}
export const ListingPriceDisplay: React.FC<ListingPriceDisplayProps> = t0 => {
  const $ = _c(7);
  const {
    priceDisplay,
    minPrice,
    maxPrice
  } = t0;
  const hasPriceDisplay = priceDisplay && priceDisplay.baseAmountCents > 100;
  const hasAnyPrice = maxPrice != null || minPrice != null || hasPriceDisplay;
  if (!hasAnyPrice) {
    return null;
  }
  let t1;
  if ($[0] !== hasPriceDisplay || $[1] !== maxPrice || $[2] !== minPrice || $[3] !== priceDisplay) {
    t1 = hasPriceDisplay ? <><div className="text-primary-main">{formatWholeDollarAmount(toInteger((priceDisplay.subtotalWithoutTaxesCents || priceDisplay.baseAmountCents) / priceDisplay.nights))}</div><div className="text-primary-main font-medium">night</div>{DISPLAY_TOTALS && priceDisplay.subtotalWithoutTaxesCents && <><div className="text-primary-main font-medium"> · </div><div className="text-primary-main">{formatWholeDollarAmount(toInteger(priceDisplay.subtotalWithoutTaxesCents))}</div><div className="text-primary-main font-medium">total</div></>}</> : minPrice != null || maxPrice != null ? minPrice != null && maxPrice != null ? <><div>Averages</div><div className="text-primary-main">{formatWholeDollarAmount(toInteger((minPrice + maxPrice) / 2))}</div><div className="font-medium text-primary-main">night</div></> : minPrice != null ? <><div>Starts at</div><div className="line-through text-gray-main">{formatWholeDollarAmount(toInteger(rateBeforeSavings(minPrice)))}</div><div className="text-primary-main">{formatWholeDollarAmount(minPrice)}</div><div className="font-medium text-primary-main">night</div></> : maxPrice != null ? <><div>Peaks at</div><div className="line-through text-gray-main">{formatWholeDollarAmount(toInteger(rateBeforeSavings(maxPrice)))}</div><div className="text-primary-main">{formatWholeDollarAmount(maxPrice)}</div><div className="font-medium text-primary-main">night</div></> : null : null;
    $[0] = hasPriceDisplay;
    $[1] = maxPrice;
    $[2] = minPrice;
    $[3] = priceDisplay;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="flex space-x-1 text-gray-dark text-xs font-semibold text-ellipsis overflow-hidden pt-0.5">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};